import { httpRequest } from "@/axios/axios-api";
import Vue from "vue";

const MOCK_EXAM_SESSION_KEY = "pc_active_mock_exam_session";

export default {
  data() {
    return {
      majorName: "", // 专业的名字
      packageExamName: "", // 试题包的名字
      questionList: [],
      currentQuestionIdx: 0,
      currentQuestion: {},
      questionAnswerList: [], // 用户已答的所有问题的列表，长度与questionList一致，存储用户的答案，每道题存储选中的选项的sort值，多选题的情况，多个选项之间以英文逗号隔开，格式为：[{"ptqrId"：123，"answer":"A,B", "eqId": 123}]
      optionSelectList: [], // 各个题目选择的状态记录，[{A:true, B:false}]
      showAnswerSheet: false, // 是否显示答题卡
      isSubmitted: false, // 是否已提交答卷
      timer: null, // 计时器
      timerDuration: 0, // 考试倒计时进行中的当前时间，秒数
      timerStr: "00:00", // 考试倒计时时间，字符串，xx:xx
      examCostTimeString: "00分00秒", // 考试结束后总用时字符串，xx分xx秒
      examTotalDuration: 0, // 考试允许总时长，秒数
      correctCount: 0, // 正确的题目数
      wrongCount: 0, // 错误的题目数
      examResultList: [], // 用户答题结果，服务器返回的，格式：[{peqId: 123, isCorrect: true}]
      ptId: null, // 当前模拟考试id，进入页面时缓存，避免路由参数丢失
      ptsrId: 0, // 当前考试的id
      accuracy: 0 // 正确率
    };
  },
  beforeRouteLeave: function(to, from, next) {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (to.name === "MockExamLib") {
      from.meta.keepAlive = false;
      this.$destroy(); //销毁
    }
    next();
  },
  created: function() {
    this.loadQuestionList();
  },
  methods: {
    parsePositiveInt(value) {
      const num = Number(value);
      if (!Number.isFinite(num) || num <= 0) {
        return null;
      }
      return Math.floor(num);
    },
    getRoutePtId() {
      return this.parsePositiveInt(this.$route.query.ptId);
    },
    getCachedExamSession() {
      try {
        const raw = sessionStorage.getItem(MOCK_EXAM_SESSION_KEY);
        if (!raw) {
          return null;
        }
        const parsed = JSON.parse(raw);
        return {
          ptId: this.parsePositiveInt(parsed && parsed.ptId),
          ptsrId: this.parsePositiveInt(parsed && parsed.ptsrId)
        };
      } catch (error) {
        sessionStorage.removeItem(MOCK_EXAM_SESSION_KEY);
        return null;
      }
    },
    persistExamSession() {
      sessionStorage.setItem(
        MOCK_EXAM_SESSION_KEY,
        JSON.stringify({
          ptId: this.parsePositiveInt(this.ptId),
          ptsrId: this.parsePositiveInt(this.ptsrId)
        })
      );
    },
    clearExamSession() {
      sessionStorage.removeItem(MOCK_EXAM_SESSION_KEY);
    },
    // 加载当前问题的统一方法
    renderQuestion() {
      this.currentQuestion = this.questionList[this.currentQuestionIdx];
      this.showAnswerSheet = false;
    },
    async loadQuestionList() {
      const currentPtId = this.getRoutePtId();
      if (!currentPtId) {
        this.$message.error("模拟考试参数异常，请返回重新进入");
        return;
      }
      this.ptId = currentPtId;
      const loadingInstance = this.$loading({ text: "加载中" });
      const params = {
        ptId: this.ptId // 模拟考试的id
      };
      const res = await httpRequest(
        "/app/practice-test/questions",
        "get",
        params
      );
      if (res !== null && res !== undefined && res.code === 200) {
        if (
          res.data === null ||
          res.data === undefined ||
          res.data.length === 0 ||
          res.data.examQuestionList === null ||
          res.data.examQuestionList === undefined ||
          res.data.examQuestionList.length === 0
        ) {
          this.$message.error("问题列表为空");
          loadingInstance.close();
          return;
        }
        this.questionList = res.data.examQuestionList;
        this.majorName = res.data.majorName;
        this.packageExamName = res.data.packageExamName;
        this.timerDuration = res.data.practiceTestDuration;
        this.examTotalDuration = res.data.practiceTestDuration;
        this.ptsrId = res.data.ptsrId;
        this.persistExamSession();

        if (
          this.questionList === null ||
          this.questionList === undefined ||
          this.questionList.length === 0
        ) {
          this.$message.error("问题列表为空");
          loadingInstance.close();
          return;
        }
        // 初始化用户答案列表参数questionAnswerList，与问题个数相同，每一个都设置格式为：{"peqid"："123"，"answer":"A,B"}
        this.questionAnswerList = new Array(this.questionList.length);
        this.optionSelectList = new Array(this.questionList.length);
        for (
          let qalIdx = 0;
          qalIdx < this.questionAnswerList.length;
          qalIdx++
        ) {
          this.questionAnswerList[qalIdx] = {
            ptqrId: this.questionList[qalIdx].ptqrId,
            answer: "",
            eqId: this.questionList[qalIdx].eqId
          }; // 初始化为未作答状态
          const options = this.questionList[qalIdx].optionList;
          // eslint-disable-next-line prefer-const
          let optionObj = {}; // {A:true, B:false}
          options.forEach(option => {
            Vue.set(optionObj, option.sort, false); // 每道题的每个选项的选中状态都先设置为false
          });
          Vue.set(this.optionSelectList, qalIdx, optionObj);
        }

        this.renderQuestion();
        // 开启定时器
        if (this.timer !== null) {
          clearInterval(this.timer);
        }
        const _this = this;
        _this.timerStr =
          (_this.timerDuration / 60 < 10
            ? "0" + parseInt(Math.max(0, parseInt(_this.timerDuration / 60)))
            : parseInt(Math.max(0, parseInt(_this.timerDuration) / 60))) +
          ":" +
          (_this.timerDuration % 60 < 10
            ? "0" + parseInt(_this.timerDuration % 60)
            : parseInt(_this.timerDuration % 60));
        this.timer = setInterval(function() {
          _this.timerDuration--;
          _this.timerStr =
            (_this.timerDuration / 60 < 10
              ? "0" + parseInt(Math.max(0, parseInt(_this.timerDuration / 60)))
              : parseInt(Math.max(0, parseInt(_this.timerDuration) / 60))) +
            ":" +
            (_this.timerDuration % 60 < 10
              ? "0" + parseInt(_this.timerDuration % 60)
              : parseInt(_this.timerDuration % 60));
          if (_this.timerDuration <= 0) {
            // 提交问卷
            clearInterval(_this.timer);
            // 弹窗提醒
            _this.$alert("倒计时结束，自动交卷", "提示", {
              confirmButtonText: "确定",
              closeOnHashChange: false,
              showClose: false,
              callback: () => {
                _this.submitAnswers();
              }
            });
          }
        }, 1000);
      }
      loadingInstance.close();
    },
    // 点击单个选项时触发的事件
    answer_question(sort) {
      let curUserAnswer = this.questionAnswerList[this.currentQuestionIdx][
        "answer"
      ]; // 用户已经选中的答案

      // 如果已经选了，则取消选择，如果没有选，则选中
      if (this.optionSelectList[this.currentQuestionIdx][sort]) {
        // 从用户答案中取消这个答案
        // eslint-disable-next-line prefer-const
        let curUserAnswerList = curUserAnswer.split(",");
        for (let uaIdx = 0; uaIdx < curUserAnswerList.length; uaIdx++) {
          if (curUserAnswerList[uaIdx] === sort) {
            curUserAnswerList.splice(uaIdx, 1);
            break;
          }
        }
        this.questionAnswerList[this.currentQuestionIdx][
          "answer"
        ] = curUserAnswerList.join(",");
      } else {
        // 如果没选中，就选择上
        // 此时需要区分单选题还是多选题
        // 单选题的情况，要先把所有选项清空，再将当前选中的设置进去
        if (this.currentQuestion.type === 0) {
          // 单选题，清空用户已经选中的
          this.questionAnswerList[this.currentQuestionIdx]["answer"] = "";
          // eslint-disable-next-line prefer-const
          for (let curSort in this.optionSelectList[this.currentQuestionIdx]) {
            Vue.set(
              this.optionSelectList[this.currentQuestionIdx],
              curSort,
              false
            );
          }
          curUserAnswer = sort;
        } else {
          curUserAnswer.length > 0
            ? (curUserAnswer += "," + sort)
            : (curUserAnswer += sort);
        }

        this.questionAnswerList[this.currentQuestionIdx][
          "answer"
        ] = curUserAnswer;
      }
      // 最后设置选中状态
      this.optionSelectList[this.currentQuestionIdx][sort] = !this
        .optionSelectList[this.currentQuestionIdx][sort];
    },
    // 上一题
    previous_question() {
      if (this.currentQuestionIdx > 0) {
        this.currentQuestionIdx--;
        this.renderQuestion();
      }
    },
    // 下一题
    next_question() {
      if (this.currentQuestionIdx < this.questionList.length - 1) {
        this.currentQuestionIdx++;
        this.renderQuestion();
      } else {
        this.submitExam();
      }
    },
    // 跳到指定问题
    jump2Question(index) {
      this.currentQuestionIdx = index;
      this.renderQuestion();
    },
    // 提交问卷
    submitExam() {
      // 弹窗提醒用户是否提交问卷
      this.$confirm("确认要提交问卷吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.submitAnswers();
        })
        .catch(() => {});
    },
    async submitAnswers() {
      // 提交问卷
      const loadingInstance = this.$loading({ text: "正在提交" });
      if (this.timer !== null) {
        clearInterval(this.timer);
      }
      const _this = this;
      const cachedExamSession = _this.getCachedExamSession() || {};
      const currentPtId =
        _this.ptId || _this.getRoutePtId() || cachedExamSession.ptId;
      const currentPtsrId = _this.ptsrId || cachedExamSession.ptsrId;
      if (!currentPtId) {
        loadingInstance.close();
        _this.$message.error("模拟考试参数异常，请返回重新进入");
        return;
      }
      if (!currentPtsrId) {
        loadingInstance.close();
        _this.$message.error("模拟考试统计信息异常，请返回重新进入");
        return;
      }
      _this.ptId = currentPtId;
      _this.ptsrId = currentPtsrId;
      _this.persistExamSession();
      const data = {
        ptId: currentPtId,
        userAnswerList: _this.questionAnswerList,
        ptsrId: currentPtsrId,
        token: _this.$route.query.token
      };
      const res = await httpRequest(
        "/app/practice-test/answer-list",
        "put",
        data,
        {
          timeout: 30000,
          preserveErrorResponse: true,
          silentErrorMessage: true
        }
      );
      if (res !== null && res !== undefined && res.code === 200) {
        _this.clearExamSession();
        _this.$message.success("问卷已提交");
        // 显示答卷结果
        _this.isSubmitted = true;
        _this.examResultList = res.data.questions;
        _this.correctCount = res.data.isCorrectCount;
        _this.wrongCount = res.data.wrongCount;
        _this.accuracy = res.data.accuracy;
        // 计算考试用时
        const cost = _this.examTotalDuration - _this.timerDuration;
        _this.examCostTimeString =
          (cost / 60 < 10
            ? "0" + parseInt(Math.max(0, parseInt(cost / 60)))
            : parseInt(Math.max(0, parseInt(cost / 60)))) +
          "分" +
          (cost % 60 < 10 ? "0" + parseInt(cost % 60) : parseInt(cost % 60)) +
          "秒";
      } else {
        // 出错的情况，弹窗重试
        _this.$alert((res && res.message) || "提交出错，点击重试", "提示", {
          confirmButtonText: "确定",
          closeOnHashChange: false,
          showClose: false,
          callback: () => {
            _this.submitAnswers();
          }
        });
      }
      loadingInstance.close();
    },
    go2AnalysisPage(isWrongMode) {
      // 参数表示是否为错题解析模式
      if (isWrongMode) {
        // 如果是错题模式，得看看错误数是否大于0
        if (this.wrongCount <= 0) {
          this.$message.error("您没有错题");
          return;
        }
      }
      // 去解析页面
      this.$router.push({
        path: "/mockExamAnalysis",
        query: {
          userAnswerList: this.questionAnswerList,
          userAnswerResultList: this.examResultList,
          isWrongMode: isWrongMode,
          packageExamName: this.packageExamName
        }
      });
    }
  }
};
